 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		61: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"0":"common-ArticlePage-FrontPage-IdxPage-LiveRadioPage-MediaAssetPage-MostReadPage-OnDemandRadioPage-OnD-eb5083ef","1":"common-ArticlePage-ErrorPage-FrontPage-IdxPage-LiveRadioPage-MediaAssetPage-MostReadPage-OnDemandRad-dac43e9e","2":"common-FrontPage-IdxPage-MediaAssetPage-PhotoGalleryPage-StoryPage-31ecd969","3":"afaanoromoo-31ecd969","4":"afrique-31ecd969","5":"amharic-31ecd969","6":"arabic-31ecd969","7":"archive-31ecd969","8":"azeri-31ecd969","9":"bengali-31ecd969","10":"burmese-31ecd969","11":"cymrufyw-31ecd969","12":"gahuza-31ecd969","13":"gujarati-31ecd969","14":"hausa-31ecd969","15":"hindi-31ecd969","16":"igbo-31ecd969","17":"indonesia-31ecd969","18":"japanese-31ecd969","19":"korean-31ecd969","20":"kyrgyz-31ecd969","21":"marathi-31ecd969","22":"mundo-31ecd969","23":"naidheachdan-31ecd969","24":"nepali-31ecd969","25":"news-31ecd969","26":"pashto-31ecd969","27":"persian-31ecd969","28":"pidgin-31ecd969","29":"portuguese-31ecd969","30":"punjabi-31ecd969","31":"russian-31ecd969","32":"scotland-31ecd969","33":"serbian-31ecd969","34":"sinhala-31ecd969","35":"somali-31ecd969","36":"swahili-31ecd969","37":"tamil-31ecd969","38":"telugu-31ecd969","39":"thai-31ecd969","40":"tigrinya-31ecd969","41":"turkce-31ecd969","42":"ukchina-31ecd969","43":"ukrainian-31ecd969","44":"urdu-31ecd969","45":"uzbek-31ecd969","46":"vietnamese-31ecd969","47":"yoruba-31ecd969","48":"zhongwen-31ecd969","49":"common-LiveRadioPage-OnDemandRadioPage-31ecd969","50":"ArticlePage-31ecd969","51":"ErrorPage-31ecd969","52":"FrontPage-31ecd969","53":"IdxPage-31ecd969","54":"LiveRadioPage-73a40977","55":"MediaAssetPage-31ecd969","56":"MostReadPage-31ecd969","57":"OnDemandRadioPage-88a3c260","58":"OnDemandTvPage-31ecd969","59":"PhotoGalleryPage-31ecd969","60":"StoryPage-31ecd969","62":"rich-text-transforms-748942c6"}[chunkId]||chunkId) + "." + {"0":"f5734089","1":"7d472deb","2":"844292e1","3":"3d244ab7","4":"cb0d9021","5":"21fb4c3d","6":"80f74c9d","7":"bb66a35b","8":"58cd56c9","9":"f7b69270","10":"fa515c6e","11":"f84d4517","12":"ab7dca66","13":"2b49f7c3","14":"4a9946a6","15":"0d08bfc7","16":"ddc8f6da","17":"9fb65d7c","18":"ca30efb4","19":"901deae7","20":"11b97739","21":"c297a064","22":"a12b36aa","23":"4bc1bdb5","24":"7aadfe2c","25":"63856329","26":"5152eb80","27":"350e56c9","28":"ee10741b","29":"958257c5","30":"0b110595","31":"f6fbc9b3","32":"97a2f11e","33":"60a7d132","34":"ad923ee7","35":"cca116a2","36":"1ffc720d","37":"30e76778","38":"de6f9c66","39":"4b904dd6","40":"147c0184","41":"5ca2029a","42":"cc14fda3","43":"80a763e0","44":"938f9a75","45":"b496b0b6","46":"49ac337b","47":"1689898b","48":"71c63991","49":"0fb615f7","50":"ef606e04","51":"ff1817b0","52":"75829053","53":"351f9d5f","54":"90132530","55":"32c1c5c0","56":"a4227c8f","57":"537e472a","58":"2c166cb1","59":"d36b30d7","60":"3ebd692a","62":"32facd4b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://news.files.bbci.co.uk/include/articles/public/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,63,64]);
 	// run deferred modules when ready
 	return checkDeferredModules();
